var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V5.83333C17.5 6.75381 16.7538 7.5 15.8333 7.5H4.16667C3.24619 7.5 2.5 6.75381 2.5 5.83333V4.16667ZM15.8333 4.16667H4.16667V5.83333H15.8333V4.16667ZM2.5 10.8333C2.5 9.91286 3.24619 9.16667 4.16667 9.16667H9.16667C10.0871 9.16667 10.8333 9.91286 10.8333 10.8333V15.8333C10.8333 16.7538 10.0871 17.5 9.16667 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V10.8333ZM9.16667 10.8333H4.16667V15.8333H9.16667V10.8333ZM12.5 10.8333C12.5 9.91286 13.2462 9.16667 14.1667 9.16667H15.8333C16.7538 9.16667 17.5 9.91286 17.5 10.8333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H14.1667C13.2462 17.5 12.5 16.7538 12.5 15.8333V10.8333ZM15.8333 10.8333H14.1667V15.8333H15.8333V10.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.075f77446c99b878e4ce9d5154bef2fb.svg";
export { ForwardRef as ReactComponent };